import { useContext } from 'react';
import { SyncContext } from 'contexts/sync';
const FavoritesTotal = () => {
    const { syncData } = useContext(SyncContext);
    return `${syncData.Favorites.Total}`;
}

export default FavoritesTotal;